/**
 * The type scale of the brand profile. Every card uses these and nothing else, so the page reads as
 * one voice: a key statement, a body text, a small label, small meta text, and a chip.
 */
export const T = {
  /** The one thing a card says: a persona, a territory title, a value, a age or gender. */
  key: "text-[15px] font-medium leading-relaxed text-foreground",
  /** Same size, heavier, for a short title inside a card. */
  keyStrong: "text-[15px] font-semibold leading-snug tracking-tight text-foreground",
  /** Supporting text under a key statement, or free text the brand wrote. */
  body: "text-[14px] leading-relaxed text-foreground/75",
  /** Small caps labels: "Industry", "Product line", "Competition", "Age", "Gender". */
  label: "text-[12px] font-semibold uppercase tracking-[0.12em] text-muted-foreground/70",
  /** A hint under a label or a step. */
  hint: "text-[13px] leading-snug text-muted-foreground",
  /** Legends, ticks. */
  meta: "text-[12px] text-muted-foreground",
} as const;
